import * as XLSX from "xlsx";

const DAGEN = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag"];
const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
const slug = (s) => (String(s).replace(/[^\w\-]+/g, "_").replace(/_+/g, "_").replace(/^_|_$/g, "") || "bureau").slice(0, 40);
const sheetName = (s) => String(s).replace(/[\\/?*[\]:]/g, " ").slice(0, 31) || "Bureau";
const fmtDate = (iso) => { const [y, m, d] = String(iso).split("-"); return `${d}-${m}-${y}`; };
const nrCell = (nr) => { const s = String(nr || "").trim(); if (!s) return ""; const n = Number(s); return /^\d+$/.test(s) && Number.isSafeInteger(n) ? n : s; };

// cel: { type: "klok"|"afw"|"vast"|"leeg", in, uit, pauze, neto, tekst, vergeten }
const dagTekst = (c) => (c.type === "afw" ? c.tekst : c.type === "vast" ? "Gewerkt" : "Vrij");

// rows zijn al gesorteerd op personeelsnummer (TijdregistratieSectie.buildRows)
export function bureauSheet({ bureau, jaar, week, dates, rows }) {
  const aoa = [];
  aoa.push([`Gewerkte uren — ${bureau}`]);
  aoa.push([`Week ${week} · ${jaar} · ${fmtDate(dates[0])} t/m ${fmtDate(dates[4])}`, "", "", "", "", "", "", "", "Clazing Convenience Food B.V."]);
  aoa.push([]);
  aoa.push(["OVERZICHT NETTO UREN"]);
  aoa.push(["Pers.nr", "Medewerker", ...DAGEN.map((d, i) => `${d.slice(0, 2)} ${fmtDate(dates[i]).slice(0, 5)}`), "Totaal"]);
  const tot = [0, 0, 0, 0, 0];
  rows.forEach((r) => {
    const cells = r.dagen.map((c, i) => { if (c.type === "klok") { tot[i] += c.neto; return r2(c.neto); } return dagTekst(c); });
    aoa.push([nrCell(r.nr), r.naam, ...cells, r.totaal == null ? "" : r2(r.totaal)]);
  });
  aoa.push(["", "Totaal", ...tot.map(r2), r2(tot.reduce((s, v) => s + v, 0))]);
  aoa.push([]);
  aoa.push(["DETAIL PER DAG (in / uit / pauze / netto)"]);
  aoa.push(["Pers.nr", "Medewerker", "Dag", "Datum", "In", "Uit", "Pauze (min)", "Netto uren", "Status"]);
  rows.forEach((r) => {
    r.dagen.forEach((c, i) => {
      if (c.type === "klok") aoa.push([nrCell(r.nr), r.naam, DAGEN[i], fmtDate(dates[i]), c.in, c.uit, c.pauze, r2(c.neto), c.vergeten ? "Niet uitgeklokt" : "Gewerkt"]);
      else aoa.push([nrCell(r.nr), r.naam, DAGEN[i], fmtDate(dates[i]), "", "", "", "", dagTekst(c)]);
    });
    aoa.push([nrCell(r.nr), r.naam, "Totaal", "", "", "", "", r.totaal == null ? "" : r2(r.totaal), ""]);
  });
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = [{ wch: 9 }, { wch: 28 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 12 }, { wch: 16 }];
  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }];
  return ws;
}

export function excelBureau(args) {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, bureauSheet(args), sheetName(args.bureau));
  XLSX.writeFile(wb, `gewerkte-uren_${slug(args.bureau)}_week${args.week}-${args.jaar}.xlsx`);
}

export function excelAlleBureaus({ jaar, week, dates, groepen }) {
  const wb = XLSX.utils.book_new();
  const used = new Set();
  groepen.forEach(({ bureau, rows }) => {
    let n = sheetName(bureau); let k = 2; while (used.has(n)) n = `${sheetName(bureau).slice(0, 28)} ${k++}`; used.add(n);
    XLSX.utils.book_append_sheet(wb, bureauSheet({ bureau, jaar, week, dates, rows }), n);
  });
  XLSX.writeFile(wb, `gewerkte-uren_alle-bureaus_week${week}-${jaar}.xlsx`);
}
